import { useState, useEffect } from 'react';

const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState({
    isLarge: false,
    isMedium: false,
    isSmall: true,
  });

  useEffect(() => {
    const largeQuery = window.matchMedia('(min-width: 950px)');
    const mediumQuery = window.matchMedia(
      '(min-width: 744px) and (max-width: 949px)'
    );

    const updateScreenSize = () => {
      setScreenSize({
        isLarge: largeQuery.matches,
        isMedium: mediumQuery.matches,
        isSmall: !largeQuery.matches && !mediumQuery.matches,
      });
    };

    updateScreenSize();

    largeQuery.addEventListener('change', updateScreenSize);
    mediumQuery.addEventListener('change', updateScreenSize);

    return () => {
      largeQuery.removeEventListener('change', updateScreenSize);
      mediumQuery.removeEventListener('change', updateScreenSize);
    };
  }, []);

  return screenSize;
};

export default useScreenSize;
